<template>
  <div>
    <div
      :id="id"
      class="trend"
      :class="trendClasses"
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      :title="tooltip"
    >
      <i :class="`bi bi-${icon} fs-3`"></i>
    </div>
  </div>
</template>

<script>
import {
  getTrendDataForAverages,
  getTrendTextForStatItem
} from '@/helpers/trend-helpers'

export default {
  name: 'TrendArrow',
  props: {
    id: {
      type: String,
      required: true
    },
    class: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      required: true
    },
    regressionValues: {
      type: Array,
      required: true
    },
    averages: {
      type: Array,
      default: () => []
    },
    theme: {
      type: String,
      default: 'default'
    },
    useColor: {
      type: Boolean,
      default: false
    },
    zeroToHundred: {
      type: Boolean,
      default: false
    },
    shouldShowNoTrendDash: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    trendData() {
      return getTrendDataForAverages({
        averages: this.averages,
        regressionValues: this.regressionValues,
        zeroToHundred: this.zeroToHundred
      })
    },
    tooltip() {
      return getTrendTextForStatItem({
        statItem: {
          averages: this.averages,
          regressionValues: this.regressionValues
        },
        title: this.title,
        t: this.$t,
        trendData: this.trendData
      })
    },
    trendClasses() {
      if (this.trendData) {
        let color = 'text-gray'
        if (this.useColor && this.theme && this.theme !== 'monochrome') {
          if (this.trendData.trend === 'increased') {
            color = 'text-success'
          } else if (this.trendData.trend === 'decreased') {
            color = 'text-danger'
          }
        }
        const isClickable =
          this.type === 'category' ||
          this.type === 'tag' ||
          this.type === 'enps'
        return `${this.class} ${this.trendData.trend} ${color} ${isClickable ? 'cursor-pointer' : ''}`
      }
      return `${this.class}`
    },
    icon() {
      if (this.trendData && this.trendData.trend !== 'noTrend') {
        return 'arrow-right'
      } else if (this.shouldShowNoTrendDash) {
        return 'dash'
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.trend {
  cursor: default;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text-success > i {
  color: var(--kt-text-success) !important;
}
.text-danger > i {
  color: var(--kt-text-danger) !important;
}

.increased {
  transform: rotate(-45deg);
}
.decreased {
  transform: rotate(45deg);
}

.no-indicator {
  width: 34px;
  height: 34px;
}
</style>
